import { render, staticRenderFns } from "./ed-class-header.component.vue?vue&type=template&id=3f866a84&scoped=true&"
import script from "./ed-class-header.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-header.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-header.component.scss?vue&type=style&index=0&id=3f866a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f866a84",
  null
  
)

export default component.exports